module.exports = __webpack_public_path__ + "static/media/avatar_default.73260faa.svg";